import { Link } from 'react-router-dom';
import { siteStats, aboutInfo } from '@/mocks/zh/home';

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-[40%]">
            <span className="inline-block px-3 py-1 rounded-full border border-background-300 text-xs text-foreground-500 mb-5">
              关于平台
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4 leading-tight">
              🍉 你身边的
              <br />
              <span className="text-foreground-600 font-normal">吃瓜第一站</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {aboutInfo.description}
            </p>
            <div className="flex flex-wrap gap-2 mb-6">
              {aboutInfo.values.map((v) => (
                <span
                  key={v}
                  className="px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-medium whitespace-nowrap"
                >
                  {v}
                </span>
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap group"
            >
              了解更多
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>

          <div className="lg:w-[60%] flex flex-col gap-8">
            <div className="flex flex-wrap gap-8 md:gap-12 justify-end">
              {[
                { num: '580万+', label: '日访问量' },
                { num: '1.2万+', label: '视频总量' },
              ].map((stat) => (
                <div key={stat.label} className="text-right">
                  <div className="text-2xl md:text-3xl font-bold text-foreground-950">{stat.num}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="relative h-[320px] md:h-[380px]">
              <div className="absolute top-0 left-0 w-[55%] h-[70%] rounded-xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20content%20creation%20team%20working%20in%20a%20stylish%20office%20with%20multiple%20monitors%20displaying%20social%20media%20dashboards%2C%20warm%20amber%20lighting%2C%20creative%20workspace%20vibe%2C%20editorial%20photography%2C%20natural%20poses%2C%20professional%20yet%20casual%20atmosphere&width=600&height=800&seq=chigua-about-team&orientation=portrait"
                  alt="吃瓜视频团队工作场景"
                  title="吃瓜视频专业团队"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute bottom-0 right-0 w-[55%] h-[75%] rounded-xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20media%20editing%20room%20with%20multiple%20screens%20showing%20video%20content%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%20with%20plants%20and%20art%2C%20editorial%20photography%2C%20relaxed%20professional%20atmosphere&width=600&height=800&seq=chigua-about-office&orientation=portrait"
                  alt="吃瓜视频工作室环境"
                  title="吃瓜视频编辑工作室"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}